import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=5a161f2c&scoped=true"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=5a161f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a161f2c",
  null
  
)

export default component.exports